import { React, useState, useEffect, useRef } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
} from "../../styledElements";
import { Tooltip, Button, Row, Col, Form, Input, PageHeader } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import "antd-country-phone-input/dist/index.css";
import "flagpack/dist/flagpack.css";

import { GlobalSet, Styled } from "../../pageStyled";

import SerialNumberConfigDrawer from "./SerialNumberConfigDrawer";
import { getJobCardSerialNumberParam } from "../../../Services/settingsServices";

//import OrderToleranceDrawer from "./orderToleranceDrawer";

const JobCardSerailNoConfig = (props) => {
  // const [switchCase, setSwitchCase] = useState();
  
  const [settings, setSettings] = useState();
 ;  const [isSerialNumberDrawerVisible,setIsSerialNumberDrawerVisible] = useState(false);
  
 const [form] = Form.useForm();
 const [previewCode, setPreviewCode] = useState("");
const [isDataChange,setIsDataChange] = useState(true);

 useEffect(async () => {
  let params = "";
  if(isDataChange)
  {
  const records = await getJobCardSerialNumberParam();
  if (records) {
    let jcCode = "";
    for (let index = 0; index < records.data.jobcard_code_config.length; index++) {
      let param = records.data.jobcard_code_config[index];

      switch (records.data.jobcard_code_config[index].name) {
        case "fixed_code":
          jcCode =
            jcCode +
            param.value +
            param.separator.value;
          break;
        case "year":
          jcCode = jcCode + "2021"  +
          param.separator.value;;

          break;
        case "month":
          if (param.type == "name")
            jcCode =
              jcCode + "April"  +
              param.separator.value;
          else
            jcCode = jcCode + "04"  +
            param.separator.value;;
          break;
        case "day":
          jcCode = jcCode + "01"  +
          param.separator.value;
          break;
        case "machine":
          if (param.type == "name")
            jcCode =
              jcCode + "MachineEX" + 
              param.separator.value;
          else
            jcCode =
              jcCode + "M1001" +
              param.separator.value;
          break;
        case "series":
          jcCode =
            jcCode +
            param.initiator +
            param.separator.value;
          break;
      }
    }
   setPreviewCode(jcCode);

  }
  setIsDataChange(false);
}
}, [isDataChange]);

useEffect(async () => {
  if(previewCode)
  {
  form.setFieldsValue({'config':previewCode})
  }
},[previewCode]);

  const onOpenSerialNumberDrawer = () =>{
    setIsSerialNumberDrawerVisible(true);
  } 

  const onCloseDrawer = () =>{
    setIsSerialNumberDrawerVisible(false);
  }

 
  const onIsDataChange = () => {
    setIsDataChange(true);
  }
  
  return previewCode ? (
    <RightLayoutContainer className="globalset">
      <PageTitleComp>
        <PageHeader
          ghost={false}
          title="Serial Number Config"
          // extra={[
          //     <Button key="3" className="textTypeBtn">Cancel changes</Button>,
          //     <Button key="2" className="themeBtn"><Iconmoon icon="addcircle" size={14} color="#ffffff" />Save</Button>,
          //     <Button key="1" className="themeBtn"><Iconmoon icon="edit" size={14} color="#ffffff" />Edit</Button>,
          // ]}
        ></PageHeader>
      </PageTitleComp>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form name="basic" autoComplete="off" className="haberLogin"
            form={form}>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Job Card Number</h2>
                    <p>The defined serial number will be used as 
                        to display jobcard number in tables and reports
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Format Preview</label>
                        <p>
                          The sequence of parameters can be previewed here
                        </p>
                      </div>
                    </Col>
                    <Col span={10}>
                    <div className="boxFormType">
                        <Form.Item
                              name={`config`}                    >
                           <Input.TextArea
                                  disabled
                                  autoSize={{ minRows: 1, maxRows: 6 }}
                                />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={2}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Styled>
                            <Tooltip
                              className="edit-tooltip"
                              placement="bottomRight"
                              title={
                                "Configure job card serial number"
                              }
                              getPopupContainer={(triggerNode) => triggerNode}
                            >
                              <Button key="3" className="textTypeBtn" style={{top:'1 !important'}}
                              onClick={onOpenSerialNumberDrawer}>
                                <Iconmoon
                                  icon={"setting"}
                                  size={16}
                                  color="#605E5C"
                                />
                              </Button>
                            </Tooltip>
                           
                          </Styled>
                        </GlobalSet>
                      </div>
                    </Col>
                  </Row>
                
                </Col>
              </Row>

            </Form>
          </div>
        </HaberForm>
      </DetailFields>
      {isSerialNumberDrawerVisible && (
        <SerialNumberConfigDrawer
          visible={isSerialNumberDrawerVisible}
          onClose = {onCloseDrawer} 
          onSave = {onIsDataChange}
          
        ></SerialNumberConfigDrawer>
      )}
</RightLayoutContainer>
  ) : (
    <></>
  );
};
export default JobCardSerailNoConfig;
